import React from 'react'
import { Redirect } from 'react-router-dom'
import { Body } from 'components/Shell/Shell'
import { Spinner } from 'components/Loaders/Loaders'
import Search from 'components/Search/Search'
import { GET_HAS_FARM_BILL_SUBSCRIPTION } from 'requests'

const FarmBill = props => {
  const [hasSubscription, setHasSubscription] = React.useState(null)
  const [sortBy, setSortBy] = React.useState(null)
  const [sortByDirection, setSortByDirection] = React.useState(null)
  const [searchOnNextTick, setSearchOnNextTick] = React.useState(false);
  const searchTrigger = React.useRef()

  React.useEffect(() => {
    GET_HAS_FARM_BILL_SUBSCRIPTION(
      response => {
        setHasSubscription(response)
      },
      err => {
        console.error(err)
        setHasSubscription(false)
      }
    )
  }, [])

  React.useEffect(() => {
    if(searchOnNextTick){
      searchTrigger.current();
      setSearchOnNextTick(false);
    }
  }, [searchOnNextTick])

  const setSorting = sortId => {
    setSortBy(sortId)
    if (!sortByDirection || sortId !== sortBy) {
      setSortByDirection('DESC')
    } else {
      setSortByDirection(sortByDirection === 'DESC' ? 'ASC' : 'DESC')
    }
    setSearchOnNextTick(true)
  }

  return hasSubscription === null ? (
    <Body className="flex-center-page">
      <Spinner className="page-loader" themeColor="dark-neutral" />
    </Body>
  ) : hasSubscription ? (
    <Search
      {...props}
      allowEmptySearchTerm
      sortBy={sortBy}
      sortByDirection={sortByDirection}
      onHeaderLabelClicked={setSorting}
      sortable
      getSearchTrigger={x => (searchTrigger.current = x)}
      firstCellInteractive={false}
    />
  ) : (
    <Redirect to="/" />
  )
}

export default FarmBill



// WEBPACK FOOTER //
// ./src/components/FarmBill/FarmBill.js